import { createFileRoute, redirect } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { SETUP_PERMISSIONS, can, firstSetupPath, sessionQuery } from '@/shared/auth';

/** The Setup hub has no page of its own: it opens the first tab the user may see, or the in-shell "No access" view. */
export const Route = createFileRoute('/_app/setup')({
  staticData: { crumb: 'nav.setup' },
  beforeLoad: async ({ context }) => {
    await requirePermission(context.queryClient, [...SETUP_PERMISSIONS], 'Setup');
    const session = await context.queryClient.query({ ...sessionQuery, staleTime: 'static' });
    const to = firstSetupPath((p) => can(session, p));
    if (to) throw redirect({ to, replace: true });
  },
});
